module.exports = __webpack_public_path__ + "static/media/no_results.3a00cf03.svg";